export default {

  READ_CLIENTS: "/protfolio/clients/request",
  READ_CLIENTS_SUCCESS: "/protfolio/clients/success",
  READ_CLIENTS_ERROR: "/protfolio/clients/error",

  READ_SUMMARY: "/protfolio/summary/request",
  READ_SUMMARY_SUCCESS: "/protfolio/summary/success",
  READ_SUMMARY_ERROR: "/protfolio/summary/error",

  READ_REPORT: "/client/report/request",
  READ_REPORT_SUCCESS: "/client/report/success",
  READ_REPORT_ERROR: "/client/report/error",

  CREATE_CLIENTS: "/protfolio/create/request",
  CREATE_CLIENTS_SUCCESS: "/protfolio/create/success",
  CREATE_CLIENTS_ERROR: "/protfolio/create/error",

  EDIT_CLIENTS: "/protfolio/edit/request",
  EDIT_CLIENTS_SUCCESS: "/protfolio/edit/success",
  EDIT_CLIENTS_ERROR: "/protfolio/edit/error",

  DELETE_CLIENTS: "/protfolio/delete/request",
  DELETE_CLIENTS_SUCCESS: "/protfolio/delete/success",
  DELETE_CLIENTS_ERROR: "/protfolio/delete/error",


  CREATE_INTEREST: "/interest/create/request",
  CREATE_INTEREST_SUCCESS: "/interest/create/success",
  CREATE_INTEREST_ERROR: "/interest/create/error",

  EDIT_INTEREST: "/interest/edit/request",
  EDIT_INTEREST_SUCCESS: "/interest/edit/success",
  EDIT_INTEREST_ERROR: "/interest/edit/error",

  DELETE_INTEREST: "/interest/delete/request",
  DELETE_INTEREST_SUCCESS: "/interest/delete/success",
  DELETE_INTEREST_ERROR: "/interest/delete/error",


  CREATE_INVEST: "/invest/create/request",
  CREATE_INVEST_SUCCESS: "/invest/create/success",
  CREATE_INVEST_ERROR: "/invest/create/error",

  EDIT_INVEST: "/invest/edit/request",
  EDIT_INVEST_SUCCESS: "/invest/edit/success",
  EDIT_INVEST_ERROR: "/invest/edit/error",

  DELETE_INVEST: "/invest/delete/request",
  DELETE_INVEST_SUCCESS: "/invest/delete/success",
  DELETE_INVEST_ERROR: "/invest/delete/error",

  SEND_REPORT: "/report/send/request",
  SEND_REPORT_SUCCESS: "/report/send/success",
  SEND_REPORT_ERROR: "/report/send/error",
};